import { useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import ChipsDropdown from 'components/ChipsDropdown'
import { useTranslate } from 'lib/tolgee'
import { UserStore } from 'stores'
import { analyticsTracker, TOLGEE_GLOBALS } from 'utils'

interface ILanguageFilter {
  isDisabled?: boolean
}

export default function LanguageFilter({ isDisabled }: ILanguageFilter) {
  const t = useTranslate()
  const location = useLocation()
  const history = useHistory()

  const handleChange = value => {
    const newSearchParams = new URLSearchParams(location.search)
    if (value?.value) {
      newSearchParams.set('languages', String(value?.value))
    } else {
      newSearchParams.delete('languages')
    }

    // must reset territory filters
    newSearchParams.delete('topics')
    newSearchParams.delete('categories')

    const { FILTER_METRICS } = analyticsTracker.eventNames

    analyticsTracker.eventTrack(FILTER_METRICS, {
      selectedChip: value.value || 'all',
    })

    const filterSearchParams = newSearchParams.toString()
    history.push({ search: filterSearchParams })
  }

  const languageOptions = useMemo(() => {
    const userLanguages = UserStore.userLanguageOptions
      .filter(language => !language.disabled)
      .map(language => {
        return {
          value: language.value,
          label: t(TOLGEE_GLOBALS[language.value]),
        }
      })
    const availableLanguages = [...userLanguages]
    return [{ label: t(TOLGEE_GLOBALS.allLanguages), value: null }, ...availableLanguages]
  }, [t])

  const languages = useMemo(() => {
    const newSearchParams = new URLSearchParams(location.search)

    const languageValue = newSearchParams.get('languages')
    const selectedLanguage = languageOptions.find(item => item.value === languageValue)

    return languageValue ? selectedLanguage : null
  }, [languageOptions, location.search])

  return (
    <ChipsDropdown
      className="languageFilter"
      label={t(TOLGEE_GLOBALS.language)}
      onChange={handleChange}
      disabled={isDisabled}
      options={languageOptions}
      selected={languages?.value && !isDisabled ? languages : null}
    />
  )
}
